import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Arende } from '../../interfaces/arende.interface';

@Injectable()
export class ArendeInfoService {
  constructor(
    protected http: HttpClient,
    @Inject('API_URL') protected apiUrl: string) {
  }

  public getArendeInfo(instance: string, caseId?: string): Observable<Arende> {
    const url = caseId
      ? `${this.apiUrl}${instance}/arbetstagare/arendeInfo/${caseId}`
      : `${this.apiUrl}${instance}/arbetstagare/arendeInfo`;
    return this.http.get<Arende>(url);
  }
}
